import { useContext, useEffect, useState } from "react";
import { HomeContext } from "../containers/Home";
import { getPhasesAndTasks } from "../services/api-server/phases";
import { TOperationData } from "../types/operation";
import { TPhaseDataWithTasks } from "../types/phase";
import { TWellData } from "../types/well";
import OperationRelatedButtons from "./OperationRelatedButtons";
import Swimlane from "./Swimlane";
import { TProjectData } from "../types/project";

function OperationSwimlane({
	project,
	operation,
}: {
	project: TProjectData;
	operation: TOperationData & TWellData;
}) {
	const { currentTenantKey }: any = useContext(HomeContext);

	const [operationPhaseList, setOperationPhaseList] = useState<
		TPhaseDataWithTasks[]
	>([]);

	const fetchOperationPhasesAndTasks = async () => {
		try {
			const filterOperationTasks = { project_id: project._id };
			const { phase_data, task_data }: any = await getPhasesAndTasks(
				currentTenantKey,
				filterOperationTasks,
				operation._id
			);
			phase_data.forEach((phase: TPhaseDataWithTasks) => {
				phase.tasks = task_data[phase._id] || [];
			});
			setOperationPhaseList(phase_data as TPhaseDataWithTasks[]);
		} catch (error) {
			console.log(error);
		}
	};

	useEffect(() => {
		fetchOperationPhasesAndTasks();
	}, []);

	return (
		<Swimlane
			label={`${operation.well_name} > ${operation.operation_name}`}
			operation={operation}
			phases={operationPhaseList}
			extraComponent={
				<OperationRelatedButtons project={project} operation={operation} />
			}
		/>
	);
}
export default OperationSwimlane;
